(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["christmas-snow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('christmas-snow')) return;
    class ChristmasSnow extends HTMLElement {
      static instances = new Set();
      static paused = false;
      static get observedAttributes() {
        return ['data-enabled', 'data-scope', 'data-density', 'data-speed', 'data-wind', 'data-size', 'data-opacity', 'data-mobile', 'data-gold'];
      }
      static reconcile() {
        const owner = Array.from(this.instances).find(item => item.config.scope === 'page' && item.eligible());
        this.instances.forEach(item => item.sync(item.config.scope !== 'page' || item === owner));
      }
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.frame = 0;
        this.last = 0;
        this.width = 0;
        this.height = 0;
        this.particles = [];
        this.inView = false;
        this.canvas = document.createElement('canvas');
        this.canvas.className = 'christmas-snow-canvas';
        this.canvas.setAttribute('aria-hidden', 'true');
        this.canvas.dataset.owner = this.dataset.sectionId || '';
        this.context = this.canvas.getContext('2d', { alpha: true });
        this.control = document.createElement('button');
        this.control.type = 'button';
        this.control.className = 'christmas-snow-control';
        this.onPause = () => {
          ChristmasSnow.paused = !ChristmasSnow.paused;
          ChristmasSnow.reconcile();
        };
        this.control.addEventListener('click', this.onPause);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.onChange = () => {
          this.resize();
          ChristmasSnow.reconcile();
        };
        this.onUnload = event => {
          if (event.target === this || event.target.contains(this)) this.destroy();
        };
        this.tick = this.tick.bind(this);
        this.configure();
        this.motion.addEventListener('change', this.onChange);
        this.mobileQuery.addEventListener('change', this.onChange);
        window.addEventListener('resize', this.onChange, { passive: true });
        document.addEventListener('visibilitychange', this.onChange);
        document.addEventListener('shopify:section:unload', this.onUnload);
        this.resizeObserver = new ResizeObserver(this.onChange);
        this.resizeObserver.observe(this);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting);
          ChristmasSnow.reconcile();
        });
        this.intersectionObserver.observe(this);
        ChristmasSnow.instances.add(this);
        ChristmasSnow.reconcile();
      }
      disconnectedCallback() { this.destroy(); }
      attributeChangedCallback() {
        if (!this.ready) return;
        this.configure();
        ChristmasSnow.reconcile();
      }
      configure() {
        const number = (key, fallback, min, max) => {
          const value = Number(this.dataset[key]);
          return Math.min(max, Math.max(min, Number.isFinite(value) ? value : fallback));
        };
        this.config = {
          enabled: this.dataset.enabled !== 'false',
          scope: this.dataset.scope === 'section' ? 'section' : 'page',
          mobile: this.dataset.mobile !== 'false',
          gold: this.dataset.gold === 'true',
          density: number('density', 55, 10, 100),
          speed: number('speed', 24, 8, 60),
          wind: number('wind', 6, -30, 30),
          size: number('size', 7, 3, 12),
          opacity: number('opacity', 65, 10, 90) / 100
        };
        this.canvas.dataset.scope = this.config.scope;
        this.resize(true);
      }
      eligible() {
        return this.ready && this.isConnected && this.context && this.config.enabled &&
          !document.hidden && !this.motion.matches && (this.config.mobile || !this.mobileQuery.matches);
      }
      sync(owner) {
        if (!this.ready) return;
        const visible = Boolean(owner && this.eligible() && (this.config.scope === 'page' || this.inView) && this.width && this.height);
        if (visible) {
          const parent = this.config.scope === 'page' ? document.body : this.parentNode;
          if (this.control.parentNode !== parent) parent.appendChild(this.control);
          this.control.dataset.scope = this.config.scope;
          const label = ChristmasSnow.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
          this.control.setAttribute('aria-label', label || (ChristmasSnow.paused ? 'Resume snow' : 'Pause snow'));
          this.control.title = this.control.getAttribute('aria-label');
          this.control.textContent = ChristmasSnow.paused ? '▶' : 'Ⅱ';
        } else this.control.remove();
        const active = visible && !ChristmasSnow.paused;
        this.running = active;
        if (active) {
          const parent = this.config.scope === 'page' ? document.body : this;
          if (this.canvas.parentNode !== parent) parent.appendChild(this.canvas);
          this.canvas.hidden = false;
          if (!this.frame) {
            this.last = 0;
            this.frame = requestAnimationFrame(this.tick);
          }
        } else {
          cancelAnimationFrame(this.frame);
          this.frame = 0;
          this.last = 0;
          this.context?.clearRect(0, 0, this.width, this.height);
          this.canvas.hidden = true;
          if (this.config.scope === 'page' || this.canvas.parentNode === document.body) this.canvas.remove();
        }
      }
      resize(force = false) {
        if (!this.ready || !this.context) return;
        const box = this.getBoundingClientRect();
        const width = this.config.scope === 'page' ? document.documentElement.clientWidth : box.width;
        const height = this.config.scope === 'page' ? window.innerHeight : box.height;
        const dpr = Math.min(window.devicePixelRatio || 1, this.mobileQuery.matches ? 1.5 : 2);
        if (!force && width === this.width && height === this.height && dpr === this.dpr) return;
        this.width = width;
        this.height = height;
        this.dpr = dpr;
        this.canvas.width = Math.round(width * dpr);
        this.canvas.height = Math.round(height * dpr);
        this.context.setTransform(dpr, 0, 0, dpr, 0, 0);
        const count = Math.min(this.mobileQuery.matches ? 32 : 110, Math.max(8, Math.round(this.config.density * width * height / 1000000)));
        this.particles = Array.from({ length: count }, () => this.createParticle(true));
      }
      createParticle(scatter) {
        const depth = 0.25 + Math.random() * 0.75;
        return {
          x: Math.random() * this.width,
          y: scatter ? Math.random() * this.height : -14,
          depth,
          radius: this.config.size * (0.22 + depth * 0.78),
          phase: Math.random() * Math.PI * 2,
          angle: Math.random() * Math.PI,
          crystal: Math.random() < 0.24,
          gold: this.config.gold && Math.random() < 0.08
        };
      }
      tick(time) {
        this.frame = 0;
        if (!this.ready || !this.running) return;
        if (this.last && time - this.last < 1000 / 30) {
          this.frame = requestAnimationFrame(this.tick);
          return;
        }
        const delta = this.last ? Math.min((time - this.last) / 1000, 0.06) : 0;
        this.last = time;
        const ctx = this.context;
        ctx.clearRect(0, 0, this.width, this.height);
        for (const particle of this.particles) {
          particle.phase += delta * 0.5;
          particle.y += delta * this.config.speed * (0.4 + particle.depth * 0.6);
          particle.x += delta * (this.config.wind * particle.depth + Math.sin(particle.phase) * 7);
          particle.angle += delta * 0.06;
          if (particle.y > this.height + 14) Object.assign(particle, this.createParticle(false));
          if (particle.x > this.width + 14) particle.x = -14;
          if (particle.x < -14) particle.x = this.width + 14;
          ctx.save();
          ctx.translate(particle.x, particle.y);
          ctx.rotate(particle.angle);
          ctx.globalAlpha = this.config.opacity * (0.35 + particle.depth * 0.65);
          ctx.strokeStyle = particle.gold ? '#d8ba7e' : '#edf5f7';
          ctx.fillStyle = ctx.strokeStyle;
          ctx.shadowColor = 'rgba(65, 93, 107, 0.28)';
          ctx.shadowBlur = 1;
          if (particle.crystal) {
            ctx.lineWidth = 0.8;
            ctx.beginPath();
            for (let arm = 0; arm < 6; arm++) {
              ctx.moveTo(0, 0);
              ctx.lineTo(0, -particle.radius);
              ctx.moveTo(-particle.radius * 0.26, -particle.radius * 0.64);
              ctx.lineTo(0, -particle.radius * 0.4);
              ctx.lineTo(particle.radius * 0.26, -particle.radius * 0.64);
              ctx.rotate(Math.PI / 3);
            }
            ctx.stroke();
          } else {
            ctx.beginPath();
            ctx.arc(0, 0, particle.radius * 0.24, 0, Math.PI * 2);
            ctx.fill();
          }
          ctx.restore();
        }
        this.frame = requestAnimationFrame(this.tick);
      }
      destroy() {
        if (!this.ready) return;
        this.ready = false;
        this.running = false;
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.motion.removeEventListener('change', this.onChange);
        this.mobileQuery.removeEventListener('change', this.onChange);
        window.removeEventListener('resize', this.onChange);
        document.removeEventListener('visibilitychange', this.onChange);
        document.removeEventListener('shopify:section:unload', this.onUnload);
        this.resizeObserver.disconnect();
        this.intersectionObserver.disconnect();
        this.canvas.remove();
        this.control.removeEventListener('click', this.onPause);
        this.control.remove();
        this.particles = [];
        ChristmasSnow.instances.delete(this);
        ChristmasSnow.reconcile();
      }
    }
    customElements.define('christmas-snow', ChristmasSnow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    


  class StickyHeader extends HTMLElement {


    constructor() {

      super();

    }


    connectedCallback() {


      this.header = document.querySelector('.section-header');


      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always'
        ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';


      this.headerBounds = {};


      this.setHeaderHeight();


      window
        .matchMedia('(max-width: 990px)')
        .addEventListener(
          'change',
          this.setHeaderHeight.bind(this)
        );


      if (this.headerIsAlwaysSticky) {

        this.header.classList.add(
          'shopify-section-header-sticky'
        );

      };


      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.predictiveSearch =
        this.querySelector('predictive-search');


      this.onScrollHandler =
        this.onScroll.bind(this);


      this.hideHeaderOnScrollUp =
        () => this.preventReveal = true;


      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );


      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );


      this.createObserver();


    }


    setHeaderHeight() {


      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );


    }


    disconnectedCallback() {


      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );


      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );


    }


    createObserver() {


      let observer =
        new IntersectionObserver(
          (entries, observer) => {


            this.headerBounds =
              entries[0].intersectionRect;


            observer.disconnect();


          }
        );


      observer.observe(this.header);


    }


    onScroll() {


      const scrollTop =
        window.pageYOffset
        ||
        document.documentElement.scrollTop;


      if (
        this.predictiveSearch
        &&
        this.predictiveSearch.isOpen
      ) return;


      if (
        scrollTop > this.currentScrollTop
        &&
        scrollTop > this.headerBounds.bottom
      ) {


        this.header.classList.add(
          'scrolled-past-header'
        );


        if (this.preventHide) return;


        requestAnimationFrame(
          this.hide.bind(this)
        );


      } else if (
        scrollTop < this.currentScrollTop
        &&
        scrollTop > this.headerBounds.bottom
      ) {


        this.header.classList.add(
          'scrolled-past-header'
        );


        if (!this.preventReveal) {


          requestAnimationFrame(
            this.reveal.bind(this)
          );


        } else {


          window.clearTimeout(
            this.isScrolling
          );


          this.isScrolling =
            setTimeout(() => {

              this.preventReveal = false;

            }, 66);


          requestAnimationFrame(
            this.hide.bind(this)
          );


        }


      } else if (
        scrollTop <= this.headerBounds.top
      ) {


        this.header.classList.remove(
          'scrolled-past-header'
        );


        requestAnimationFrame(
          this.reset.bind(this)
        );


      }


      this.currentScrollTop = scrollTop;


    }


    hide() {


      if (this.headerIsAlwaysSticky) return;


      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );


      this.closeMenuDisclosure();

      this.closeSearchModal();


    }


    reveal() {


      if (this.headerIsAlwaysSticky) return;


      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );


      this.header.classList.remove(
        'shopify-section-header-hidden'
      );


    }


    reset() {


      if (this.headerIsAlwaysSticky) return;


      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );


    }


    closeMenuDisclosure() {


      this.disclosures =
        this.disclosures
        ||
        this.header.querySelectorAll(
          'header-menu'
        );


      this.disclosures.forEach(
        disclosure => disclosure.close()
      );


    }


    closeSearchModal() {


      this.searchModal =
        this.searchModal
        ||
        this.header.querySelector(
          'details-modal'
        );


      this.searchModal.close(false);


    }


  }


  customElements.define(
    'sticky-header',
    StickyHeader
  );



  class StaticHeader extends HTMLElement {


    constructor() {

      super();

    }


    connectedCallback() {


      this.header =
        document.querySelector(
          '.section-header'
        );


      this.setHeaderHeight();


      window
        .matchMedia('(max-width: 990px)')
        .addEventListener(
          'change',
          this.setHeaderHeight.bind(this)
        );


    }


    setHeaderHeight() {


      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );


    }


  }


  customElements.define(
    'static-header',
    StaticHeader
  );



  } catch(e) { console.error(e); }
})();
})();
